module.exports = __webpack_public_path__ + "media/images/clients/email_btn_share-aa3d3661d9d756409e82fcd3bb5279d5.png";